export const map = {
    center: {
      // kind off center of western europe
      lat: 46.2022,
      lng: 1.264
    },
    zoom: 5
};
